import styled from "styled-components";
import { TEXT_PRIMARY } from "@/constants/colors";
import { FONT_SIZE_BASE, TITLE, BODY, REGULAR, SEMI_BOLD } from "@/constants/fonts";

export const LineItemDescription = styled.div`
  color: ${TEXT_PRIMARY};
  font-family: ${TITLE};
  font-weight: ${SEMI_BOLD};
  font-size: ${FONT_SIZE_BASE};
  text-align: left;
  margin: 0px;
`;

export const LineItemSubDescription = styled.div`
  color: ${TEXT_PRIMARY}
  font-family: ${BODY};
  font-weight: ${REGULAR};
  font-size: ${FONT_SIZE_BASE};
  text-align: left;
  margin: 0px;
`;
